import * as React from 'react';
import {observer} from 'mobx-react';
import {Checkbox, FormControlLabel} from '@mui/material';
import FormSection from '../../forms/FormSection';
import FormRow from '../../forms/FormRow';
import FormColumn from '../../forms/FormColumn';
import FormDateField from '../../components/fields/FormDateField';
import FormAutocompleteField from '../../components/fields/FormAutocompleteField';
import AllowanceSubsection from './create_allowance/AllowanceSubsection';
import SubjectKindsPanels from './create_allowance/kinds/SubjectKindsPanels';
import ResolutionKindsPanels from './create_allowance/kinds/ResolutionKindsPanels';

function AllowanceScreen({allowance}) {
    const readOnly = allowance.isReadOnly();
    const subjectKindsPanels = new SubjectKindsPanels();
    const resolutionKindsPanels = new ResolutionKindsPanels();

    const commonDataSection = () => (
        <FormSection title="Datos de la Bonificación">
            <FormColumn>
                <FormRow>
                    <FormAutocompleteField label="Concepto" form={allowance.commonForm()} fieldName="concept"
                                           options={allowance.conceptOptions()} readOnly={readOnly}/>
                    <FormDateField label="Válido desde"
                                   field={allowance.commonForm().getFieldByName('validFrom')} disabled={readOnly}/>
                    <FormDateField label="Válido hasta"
                                   field={allowance.commonForm().getFieldByName('validTo')} disabled={readOnly}/>
                </FormRow>
            </FormColumn>
        </FormSection>
    );

    const beneficiarySection = () => (
        <AllowanceSubsection
            title="Beneficiario"
            placeholder="Seleccioná a quién aplica."
            kindOptions={subjectKindsPanels.options()}
            selectedKind={allowance.selectedBeneficiaryKind}
            onKindChange={(value) => allowance.selectBeneficiaryKind(value)}
            KindPanel={subjectKindsPanels.panelFor(allowance.selectedBeneficiaryKind)}
            subsectionForm={allowance.beneficiaryForm}
            allowance={allowance}
            readOnly={readOnly}
        />
    );

    const subjectScopeToggle = () => (
        <FormControlLabel
            disabled={readOnly}
            control={
                <Checkbox
                    checked={allowance.subjectDiffersFromBeneficiary}
                    onChange={(event) => allowance.setSubjectDiffersFromBeneficiary(event.target.checked)}
                />
            }
            label="Marcá esta opción cuando las facturas que cuentan para la bonificación son de razones sociales distintas al beneficiario."
        />
    );

    const subjectSection = () => (
        <AllowanceSubsection
            title="Alcance de la bonificación"
            placeholder="Seleccioná a qué razones sociales aplica."
            kindOptions={allowance.subjectKindOptions()}
            selectedKind={allowance.selectedSubjectKind}
            onKindChange={(value) => allowance.selectSubjectKind(value)}
            KindPanel={allowance.subjectKindPanelFor(allowance.selectedSubjectKind)}
            subsectionForm={allowance.subjectForm}
            allowance={allowance}
            readOnly={readOnly}
        />
    );

    const resolutionSection = () => (
        <AllowanceSubsection
            title="Resolución (cómo se aplica el beneficio)"
            placeholder="Seleccioná un tipo de resolución."
            kindOptions={resolutionKindsPanels.options()}
            selectedKind={allowance.selectedResolutionKind}
            onKindChange={(value) => allowance.selectResolutionKind(value)}
            KindPanel={resolutionKindsPanels.panelFor(allowance.selectedResolutionKind)}
            subsectionForm={allowance.resolutionForm}
            allowance={allowance}
            readOnly={readOnly}
        />
    );

    return (
        <>
            {commonDataSection()}
            {beneficiarySection()}
            {subjectScopeToggle()}
            {allowance.subjectDiffersFromBeneficiary && subjectSection()}
            {resolutionSection()}
        </>
    );
}

export default observer(AllowanceScreen);
